module.exports = __webpack_public_path__ + "static/icons/icon-12-day-d78defdfdee81f40594c1c5b5a14252c.svg";